import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { List, Avatar } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';
import DocumentProductIcon from '../../assets/images/logo-assurmax-collapsed.png';

const ProductDocuments = ({ product }) => {
  const { dispatchAPI } = useAuthContext();
  const [isLoading, setIsLoading] = useState({});
  const { message } = useErrorMessage();
  const [dataToShow, setDataToShow] = useState();

  const covers = {
    docProductASX: <img src={DocumentProductIcon} alt="Document produit icon" />
  };

  const downloadFile = async (file) => {
    const {
      _id,
      metadata: { originalName },
      contentType
    } = file;
    setIsLoading({ ...isLoading, [file._id]: true });
    try {
      const response = await dispatchAPI('GET', {
        url: `/products/files/${_id}`,
        responseType: 'blob'
      });
      const blob = new Blob([response.data], {
        type: contentType
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = originalName;
      a.click();
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setIsLoading({ ...isLoading, [file._id]: false });
  };

  useEffect(() => {
    const tab = [];
    if (product.sheet?.length > 0) tab.push(product.sheet);
    if (product.ipid?.length > 0) tab.push(product.ipid);
    if (product.cgv?.length > 0) tab.push(product.cgv);
    if (product.needs?.length > 0) tab.push(product.needs);
    if (product.autre?.length > 0) tab.push(product.autre);
    setDataToShow(tab);
    // eslint-disable-next-line
  }, []);

  return dataToShow && dataToShow.length > 0
    ? dataToShow.map(
        (data) =>
          data?.length > 0 && (
            <List
              key={data[0]?.doc_label}
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                data ? (
                  <List.Item
                    className="document-library"
                    onClick={() => downloadFile(item?.file)}
                    actions={[<DownloadOutlined key="download" />]}
                  >
                    <List.Item.Meta
                      avatar={<Avatar src={covers.docProductASX} />}
                      title={item?.doc_label?.toUpperCase()}
                      description={
                        <p style={{ color: '#aaa' }}>
                          {item?.file?.metadata?.originalName}
                        </p>
                      }
                    />
                  </List.Item>
                ) : (
                  ''
                )
              }
            />
          )
      )
    : 'Aucun document disponible';
};

ProductDocuments.propTypes = {
  product: PropTypes.shape({
    sheet: PropTypes.arrayOf(PropTypes.shape({})),
    ipid: PropTypes.arrayOf(PropTypes.shape({})),
    cgv: PropTypes.arrayOf(PropTypes.shape({})),
    needs: PropTypes.arrayOf(PropTypes.shape({})),
    autre: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};

export default ProductDocuments;
